import { createSlice } from "@reduxjs/toolkit";
import { getDataFromLocalStorage, localStorageData, setDataToLocalStorage } from "../../services/localStorage";
import { getDefaultStartDateFromNewYear } from "../../common/getDefaultDate";
import { navigationList } from "../../common/navigationList";

const initialsettingsfilterState = {
  expandedPanelPath: navigationList[0].Panel,
  selectedCustomers: [],
  selectedPortals: [],
  startDate: getDefaultStartDateFromNewYear().firstDay,
  finishDate: getDefaultStartDateFromNewYear().lastDay,
  search: "",
};

const loadStateFromLocalStorage = () => {
  const savedFilter = getDataFromLocalStorage(localStorageData.filter);
  if (savedFilter) {
    return {
      //TODO: (deploy) change panel
      expandedPanelPath: navigationList[0].Panel,
      // expandedPanelPath: navigationList[3].Panel,
      selectedCustomers: savedFilter.selectedCustomers || [],
      selectedPortals: savedFilter.selectedPortals || [],
      startDate: savedFilter.startDate || getDefaultStartDateFromNewYear().firstDay,
      finishDate: savedFilter.finishDate || getDefaultStartDateFromNewYear().lastDay,
      search: savedFilter.search || "",
    };
  }
  return null;
};
const loadedState = loadStateFromLocalStorage();

const settingsfilterSlice = createSlice({
  name: "settingsfilter",
  initialState: loadedState || initialsettingsfilterState,
  reducers: {
    onClearStore(state) {},

    onChangeStartDate(state, action) {
      state.startDate = action.payload;
      setDataToLocalStorage(localStorageData.filter, state);
    },

    onChangeFinishDate(state, action) {
      state.finishDate = action.payload;
      setDataToLocalStorage(localStorageData.filter, state);
    },

    onChangePortals(state, action) {
      state.selectedPortals = action.payload;
      setDataToLocalStorage(localStorageData.filter, state);
    },
    onChangeCustomers(state, action) {
      state.selectedCustomers = action.payload;
      setDataToLocalStorage(localStorageData.filter, state);
    },

    onChangeSearch(state, action) {
      state.search = action.payload;
      setDataToLocalStorage(localStorageData.filter, state);
    },

    setExpandedPanel(state, action) {
      state.expandedPanelPath = action.payload;
    },
  },
});

export const settingsfilterActions = settingsfilterSlice.actions;
export default settingsfilterSlice.reducer;
